module.exports = __webpack_public_path__ + "static/media/background.2f88b113.png";